import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.sub";
import _objectSpread from "C:/xampp/htdocs/clientesapp/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:/xampp/htdocs/clientesapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "C:\\xampp\\htdocs\\clientesapp\\node_modules\\core-js\\modules\\es.array.iterator.js";
import "C:\\xampp\\htdocs\\clientesapp\\node_modules\\core-js\\modules\\es.promise.js";
import "C:\\xampp\\htdocs\\clientesapp\\node_modules\\core-js\\modules\\es.object.assign.js";
import "C:\\xampp\\htdocs\\clientesapp\\node_modules\\core-js\\modules\\es.promise.finally.js";
import store from "@/store/index";
import Vue from 'vue';
import VueAxios from "vue-axios";
import axios from 'axios';
import routes from "@/routes/app/routes";
import App from "@/App";
import _i18n from '@/lang/lang_config';
import FlagIcon from 'vue-flag-icon';
import ElementUI from 'element-ui';
import("@/assets/sass/variables_clients/".concat(process.env.VUE_APP_CLIENT, "/index.scss"));
import '@/assets/sass/theme/icons'; // icon

import Vue2Filters from "@/commons/filters/index";
import myModules from "@/commons";
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
import VueTagManager from "vue-tag-manager";
import Cookies from 'js-cookie';
import VueForceNextTick from 'vue-force-next-tick';
import VueSessionStorage from 'vue-sessionstorage';
import observer from 'vue-mutation-observer'; // Import the Auth0 configuration

import { domain, clientId, audience } from "../auth_config.json"; // Import the plugin here

import { Auth0Plugin, getInstance } from "./auth";
import { setToken, setAlias } from "@/commons/utils/auth"; // Install the authentication plugin here

Vue.use(Auth0Plugin, {
  domain: domain,
  clientId: clientId,
  audience: audience,
  onRedirectCallback: function onRedirectCallback(appState) {
    routes.push(appState && appState.targetUrl ? appState.targetUrl : window.location.pathname + '/clientes');
  }
});
var instance = getInstance();
instance.$watch("loading", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(loading) {
    var token;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!loading && instance.isAuthenticated)) {
              _context.next = 8;
              break;
            }

            _context.next = 3;
            return instance.getTokenSilently();

          case 3:
            token = _context.sent;
            localStorage.setItem('TOKEN_CLIENTES', token);
            localStorage.setItem('CLIENTE', instance.user.sub);
            setToken(token);
            setAlias(instance.user.sub);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
Vue.use(observer);
Vue.use(VueSessionStorage);
Vue.use(VueForceNextTick); //Google tag manager

Vue.use(VueTagManager, {
  gtmId: process.env.VUE_APP_GTM_KEY
}); //jquery

global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $; //frame

import iFrameResize from 'iframe-resizer/js/iframeResizer';
Vue.directive('resize', {
  bind: function bind(el, _ref2) {
    var _ref2$value = _ref2.value,
        value = _ref2$value === void 0 ? {} : _ref2$value;
    el.addEventListener('load', function () {
      return iFrameResize(value, el);
    });
  }
});
Vue.use(myModules); //ReCaptcha

import VueProgrammaticInvisibleGoogleRecaptcha from 'vue-programmatic-invisible-google-recaptcha';
import { mapGetters } from "vuex";
Vue.component('vue-programmatic-invisible-google-recaptcha', VueProgrammaticInvisibleGoogleRecaptcha);

require('@/commons/utils/fa-icons');

window._ = require("lodash");
Vue.use(VueLodash, {
  name: 'custom',
  lodash: lodash
}); //filters

Vue.use(Vue2Filters); //INTERNACIONALITATION

Vue.use(FlagIcon);
Vue.config.productionTip = false; //AXIOS

Vue.use(VueAxios, axios); //ELEMENT UI

Vue.use(ElementUI, {
  size: Cookies.get('size') || 'medium',
  i18n: function i18n(key, value) {
    return _i18n.t(key, value);
  }
}); //MOMENT

var moment = require("moment");

moment.locale('uy');
Vue.use(require("vue-moment"), {
  moment: moment
}); //APP

new Vue({
  el: '#app',
  i18n: _i18n,
  components: {
    App: App
  },
  computed: _objectSpread({}, mapGetters(['loader', 'location'])),
  router: routes,
  store: store,
  render: function render(h) {
    return h(App);
  }
}).$mount("#app");
new Vue({
  i18n: _i18n,
  router: routes,
  render: function render(h) {
    return h(App);
  }
});